import getSymbolFromCurrency from 'currency-symbol-map';
import useCart from '../../features/Cart/useCart';

function useCurrencySymbol() {
  const { currency } = useCart();

  return getSymbolFromCurrency(currency);
}

export default useCurrencySymbol;
